const formInputErrorFocus = (validator, references, exclude) => {
  for (let key in Object.keys(validator)) {
    const input = Object.keys(validator)[key]

    if (input.includes('$')) return false
    if (input.includes(exclude)) return false

    if (validator[input].$error) {
      if (references[input] && references[input].$el) {
        return references[input].$el.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'})
      }
    }
    // break
  }
}

export default formInputErrorFocus
